
import React from 'react';
import { 
  Card, 
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";

interface OddsAnalysisSummaryProps {
  totalMatches: number;
  selectedYears: string[];
  selectedTeam?: string | null;
}

export const OddsAnalysisSummary: React.FC<OddsAnalysisSummaryProps> = ({ 
  totalMatches, 
  selectedYears,
  selectedTeam
}) => {
  // Create appropriate message based on team selection
  const teamMessage = selectedTeam 
    ? `for ${selectedTeam}` 
    : "across all teams";

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-xl">Odds Analysis Summary</CardTitle>
        <CardDescription>
          Analysis based on {totalMatches} matches {teamMessage} from the {selectedYears.length === 1 
            ? `${selectedYears[0]} season` 
            : `${selectedYears.join(', ')} seasons`
          }
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-gray-600">
          This analysis examines the profitability of betting on different odds ranges, showing how backing or 
          laying these odds would have performed historically.
        </p>
      </CardContent>
    </Card>
  );
};
